// extracted by mini-css-extract-plugin
module.exports = {"root":"GlobalLoader_root__37cYJ","visible":"GlobalLoader_visible__hwPMi"};